/**
 * Office.js compatibility — History API protection.
 *
 * Office.js nullifies `window.history.pushState` and `replaceState` which
 * breaks Next.js App Router navigation. This script uses
 * `Object.defineProperty` to lock in the correct methods from
 * `History.prototype` *before* Office.js loads, so when Office.js later
 * tries to assign `null` the no-op setter silently ignores it.
 *
 * Injected as an inline <script> by `<HostProvider>` whenever the
 * current `AppSurface` is an Office add-in.
 */

/**
 * Raw JavaScript source suitable for injection via `dangerouslySetInnerHTML`.
 * Must run synchronously before Office.js loads (and before React hydrates).
 */
export const HISTORY_RESTORE_SCRIPT = `
(function() {
  var h = window.history;
  var ps = History.prototype.pushState.bind(h);
  var rs = History.prototype.replaceState.bind(h);
  Object.defineProperty(h, 'pushState', {
    get: function() { return ps; },
    set: function() {},
    configurable: false
  });
  Object.defineProperty(h, 'replaceState', {
    get: function() { return rs; },
    set: function() {},
    configurable: false
  });
})();`;
